import { render, staticRenderFns } from "./editFore.vue?vue&type=template&id=6ac425e3&scoped=true&"
import script from "./editFore.vue?vue&type=script&lang=js&"
export * from "./editFore.vue?vue&type=script&lang=js&"
import style0 from "./editFore.vue?vue&type=style&index=0&id=6ac425e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac425e3",
  null
  
)

export default component.exports